// src/hooks/usePageTitle.js
import { useContext, useEffect, useRef } from 'react';
import { PageTitleContext } from '../layouts/MobileLayout';

export const usePageTitle = (title) => {
  const { setPageTitle } = useContext(PageTitleContext);
  const isInitialized = useRef(false);

  useEffect(() => {
    if (setPageTitle && title) {
      setPageTitle(title);
      isInitialized.current = true;
    }
  }, [title, setPageTitle]);

  // Cleanup: resetear título cuando se desmonte el componente
  useEffect(() => {
    return () => {
      if (setPageTitle && isInitialized.current) {
        setPageTitle('');
      }
    };
  }, [setPageTitle]);

  return setPageTitle;
};
